/**
 * GridItem Component
 *
 * A grid child with placement helpers for spans and explicit lines.
 *
 * @module @smoothie-framework/ui/components
 */
import { createNodeId } from '../../render/node-id';
import { normalizeChildrenToNodes } from '../../internal/children';
import { resolveCanonicalUtilityProps, } from '../../authoring/utility-props';
import { composeAsChildNode } from '../../authoring/as-child';
import { buildCommonUIProps, } from '../../authoring/common-props';
export function GridItem(props) {
    const { id, area, colSpan, colStart, colEnd, rowSpan, rowStart, rowEnd, asChild, as, style, role, ariaLabel, ariaLabelledBy, 'aria-labelledby': ariaLabelledByAttribute, ariaDescribedBy, className, children, 'data-ui': dataUi, ...utilityPropsInput } = props;
    const classes = ['smth-grid-item'];
    if (className) {
        classes.push(className);
    }
    const gridItemProps = {
        className: classes.join(' '),
        ...(typeof as === 'string' && as.length > 0 && { 'data-as': as }),
        ...resolveCanonicalUtilityProps({
            ...utilityPropsInput,
            area,
            colSpan,
            colStart,
            colEnd,
            rowSpan,
            rowStart,
            rowEnd,
        }),
        ...buildCommonUIProps({
            id,
            role,
            ariaLabel,
            ariaLabelledBy: ariaLabelledBy !== undefined ? ariaLabelledBy : ariaLabelledByAttribute,
            ariaDescribedBy,
            style,
            dataUi,
            defaultDataUi: 'GridItem',
        }),
    };
    if (asChild) {
        return composeAsChildNode({
            componentType: 'GridItem',
            props: gridItemProps,
            children,
            explicitDataUi: dataUi,
            semanticTagOverride: as,
        });
    }
    return {
        id: createNodeId(),
        type: 'GridItem',
        props: gridItemProps,
        children: normalizeChildren(children),
    };
}
function normalizeChildren(children) {
    return normalizeChildrenToNodes(children);
}
//# sourceMappingURL=GridItem.js.map